var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "test" } },
    [
      _c(
        "a-drawer",
        {
          staticClass: "custom",
          attrs: {
            closable: true,
            title: _vm.$t("message.privateChat"),
            visible: _vm.visible,
            placement: "right",
            width: "500",
          },
          on: { close: _vm.onClose },
        },
        [
          _c("PrivateChatMenu", [
            _c(
              "div",
              {
                attrs: { slot: "privateChatRepresentativeSlot" },
                slot: "privateChatRepresentativeSlot",
              },
              [
                _c(
                  "div",
                  { staticClass: "messageListContainer" },
                  [
                    _c(
                      "vuescroll",
                      {
                        ref: "vs",
                        attrs: { ops: _vm.ops },
                        on: { "handle-scroll": _vm.handleScroll },
                      },
                      [
                        _c("MessageList", {
                          attrs: {
                            alwaysScrollToBottom: false,
                            colors: _vm.colors,
                            "is-private-chat": true,
                            messages: _vm.getMessages(),
                            participants: _vm.getParticipants(),
                            "random-bg-color-with-name": true,
                            "show-avatar": true,
                            "show-typing-indicator": _vm.$t(
                              "message.customerTyping"
                            ),
                            ischatwindow: false,
                            "disable-translation": true,
                          },
                          on: { remove: _vm.removeMessage },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.unreadBtn
                      ? _c(
                          "div",
                          {
                            staticClass: "newPrivateMsg",
                            on: { click: _vm.scrollDown },
                          },
                          [_c("md-icon", [_vm._v("expand_more")])],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "fixed",
                      bottom: "0",
                      width: "500px",
                    },
                  },
                  [
                    _c("UserInput", {
                      attrs: {
                        id: "privateChatUserInput",
                        colors: _vm.colors,
                        onSubmit: _vm.onSubmit,
                        placeholder: _vm.$t("message.typeHere"),
                        showEmoji: true,
                        showFile: false,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }